import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { ContainerSection } from "../styles";

export const Container = styled(ContainerSection)``;

export const ContainerTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: baseline;
`;

export const HeaderText = styled.h4`
	color: #000;
	font-size: 1rem;
	font-weight: bold;
	margin-bottom: 1rem;
	margin-right: 1rem;
`;

export const RowHeaderText = styled.span`
	margin: 0;
	font-size: 13px;
	font-weight: bold;
	white-space: nowrap;
`;

export const IconClose = styled(CloseIcon)`
	&&& {
		cursor: pointer;
	}
`;
